import { css } from "@styled-system/css";

export const knownGapIconClass = css({
	display: "inline-flex",
	marginLeft: "4",
	color: "shade.60",
	cursor: "help",
	verticalAlign: "middle",
});

export const knownGapTextClass = css({
	maxWidth: "[320px]",
	fontSize: "12",
});
